export const getTitleFromRoute = (pathname) => {
  const parts = pathname.split('/').filter(Boolean)

  if (parts.length > 1) {
    return parts[1].replace(/[_-]/g, ' ').toUpperCase()
  }

  return null
}
